import grades from "./grades.json";

export default grades;
